"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseStorage = void 0;
/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

class BaseStorage {
  constructor(options = {}) {
    this.options = options;
    if (typeof this.options.keySuffix !== 'string') this.options.keySuffix = '';
  }
  getSuffixedKey(key) {
    return this.options.keySuffix ? `${key}_${this.options.keySuffix}` : key;
  }
}
exports.BaseStorage = BaseStorage;